import React, { Component } from "react";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment
} from "semantic-ui-react";

import Icon from "../Icon/index.js";

import { login } from "../../util/Auth";

import { Link } from "react-router-dom";

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      submitting: false,
      error: false
    };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      error: false
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({
      submitting: true
    });
    login(this.state.email, this.state.password).catch(error => {
      this.setState({
        error: true,
        submitting: false
      });
    });
  };

  render() {
    return (
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as="h2" inverted textAlign="center">
          <Icon icon="spout" /> &nbsp; Log in to Spout
        </Header>
        <Form size="large" onSubmit={this.handleSubmit}>
          <Segment stacked>
            <Form.Input
              fluid
              id="email"
              icon="envelope"
              iconPosition="left"
              placeholder="E-mail address"
              onChange={this.handleChange}
              value={this.state.email}
              error={this.state.error}
            />
            <Form.Input
              fluid
              id="password"
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              onChange={this.handleChange}
              value={this.state.password}
              error={this.state.error}
            />

            <Button
              primary
              fluid
              size="large"
              disabled={!this.validateForm() || this.state.submitting}
            >
              Log In
            </Button>
          </Segment>
        </Form>
        <Message>
          New to us? <Link to="/signup">Sign Up</Link>
        </Message>
      </Grid.Column>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/src/components/login/LoginForm.js